















import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class LanguageSelection extends Vue {
  private languages = ["fr_CH", "de_CH", "it_CH", "en"];
}
